var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.disabled)?_c('div',{staticClass:"ml-1 mr-1 p-0 clickable d-flex align-items-center justify-content-center circle",style:({
          'color' : this.getColor().color,
          'background' : this.getColor().background,
          'border-color' : this.getColor().border,
})},[_c('i',{class:_vm.icon,style:({ 'margin-left' : this.marginLeft })})]):_vm._e(),(_vm.disabled)?_c('div',{staticClass:"ml-1 mr-1 p-0 disabled d-flex align-items-center justify-content-center circle",style:({
          'color' : this.getColor().color,
          'background' : this.getColor().background,
          'border-color' : this.getColor().border,
          'opacity' : 0.33
  })},[_c('i',{class:_vm.icon,style:({ 'margin-left' : this.marginLeft })})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }